/* eslint-disable */
import Axios from 'axios';
import { cacheKey, sessionState } from 'appConstants';
import { setWsUrlToEU } from '../websocket';
import { cache } from 'utils/cache';
import { store } from 'redux/store';
import { setSession } from 'redux/actions';

const {
  REACT_APP_BASE_URL,
  REACT_APP_CLIENT_VER,
  REACT_APP_PRODUCT,
  REACT_APP_APP_NAME,
  REACT_APP_TIMEOUT,
  REACT_APP_API_V3,
} = process.env;

export let V3 = REACT_APP_API_V3;
export let V1 = '/v1/textrecruit';

export const axios = Axios.create({
  baseURL: REACT_APP_BASE_URL,
  timeout: REACT_APP_TIMEOUT,
  params: {
    client_ver: REACT_APP_CLIENT_VER,
    app_name: REACT_APP_APP_NAME,
    product: REACT_APP_PRODUCT,
  },
});

const refreshToken = async () => {
  try {
    const { token, ticket } = await axios.get(`${V1}/jobchat/jwt/refresh`);
    cache.set(cacheKey.TOKEN, token);
    cache.set(cacheKey.REAL_TIME_TICKET_ID, ticket);
  } catch (error) {
    clearInterval(cache.get(cacheKey.REFRESH_TOKEN_INTERVAL_ID));
    return error;
  }
};

export const updateUrlForEU = (cloudEnvironment) => {
  if (cloudEnvironment === 'awseu-prd') {
    axios.defaults.baseURL = 'https://api-aws-eu.prd.textrecruit.tools/api';
    setWsUrlToEU();
  }
};

axios.interceptors.request.use((conf) => {
  const { url } = conf;
  // Because backend APIs follow YOLO methodology
  if (url.includes('send_message')) {
    conf.params.jobchat_uuid = cache.get(cacheKey.JOB_CHAT_ID);
  } else {
    conf.params.id = cache.get(cacheKey.JOB_CHAT_ID);
  }
  conf.headers['x-session-token'] = cache.get(cacheKey.TOKEN);
  return conf;
});

const TWENTY_MINS = 20 * 60 * 1000;
const FIFTEEN_MINS = 15 * 60 * 1000;
let timeoutId = null;

const initiateRequests = ['jobchat/initiate', 'transaction/initiate'];

// Refresh token every 20 minutes.
// This interval will cease after the user:
//  1. Explicitly ends the chat session, or
//  2. Closes the browser tab, or
//  3. There's a network/connection issue
function handleTokenRefresh() {
  const existingIntervalId = cache.get(cacheKey.REFRESH_TOKEN_INTERVAL_ID);
  if (!existingIntervalId) {
    const refreshTokenIntervalId = setInterval(refreshToken, TWENTY_MINS);
    cache.set(cacheKey.REFRESH_TOKEN_INTERVAL_ID, refreshTokenIntervalId);
  }
}

// Check if user has been inactive for 15 minutes
// If so, clear the interval that refreshes the token
// and set the session state to `failed`
// This will trigger the modal to show
// and reroute the user back to the home page
function checkUserActivity(url) {
  if (
    initiateRequests.find((reqPath) => url.includes(reqPath)) ||
    url.includes('jobchat/send_message')
  ) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      clearInterval(cache.get(cacheKey.REFRESH_TOKEN_INTERVAL_ID));
      store.dispatch(setSession(sessionState.FAILED));
    }, FIFTEEN_MINS);
  }
}

axios.interceptors.response.use(
  (response) => {
    const { url } = response.config;

    checkUserActivity(url);

    if (initiateRequests.find((reqPath) => url.includes(reqPath))) {
      const { token, ticket } = response.data;

      cache.set(cacheKey.TOKEN, token);

      handleTokenRefresh();

      cache.set(cacheKey.TOKEN, token);
      cache.set(cacheKey.REAL_TIME_TICKET_ID, ticket);
      response.config.headers['x-session-token'] = token;
    }
    return response.data;
  },
  ({ response }) => {
    if (response && response.status === 400) {
      clearInterval(cache.get(cacheKey.REFRESH_TOKEN_INTERVAL_ID));
    }
    // `!response` indicates a network issue
    if (!response || response?.data?.apiResult?.message === 'Token has expired') {
      // Changing session state to `failed` will trigger the following actions:
      //  1. Show modal for user to accept starting a new chat session
      //  2. Clear cache and reset the app state
      //  3. Reroute user back to the home page
      clearInterval(cache.get(cacheKey.REFRESH_TOKEN_INTERVAL_ID));
      store.dispatch(setSession(sessionState.FAILED));
    }
    return Promise.reject(response);
  },
);
